/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { graphql, Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import CampHoc from '../../components/CampHoc';

// eslint-disable-next-line react/prop-types
const AloittelijoidenHettaPallasHiihtovaellus = ({ data }) => {
  const seo = {
    url: 'https://www.discoverlapland.fi/hiihtovaellukset/aloittelijoiden-hetta-pallas-hiihtovaellus',
    image: `https://www.discoverlapland.fi${data.imageSEO.childImageSharp.resize.src}`,
    title: 'Aloittelijoiden Hetta-Pallas Hiihtovaellus 2027',
    description:
      'Oletko haaveillut hiihtovaelluksesta Lapissa? Koe talvinen Hetta–Pallas-reitti turvallisesti eräoppaan johdolla tunturisuksilla ja ahkiota vetäen.',
  };

  return (
    <CampHoc
      heroImage={data.campBg.childImageSharp.gatsbyImageData}
      seo={seo}
      camp="aloittelijoiden-hetta-pallas-hiihtovaellus"
    >
      <div className="camp-text-content">
        <h2>Aloittelijoiden Hetta-Pallas Hiihtovaellus</h2>
        <h3>10.-14.3.2027</h3>
        <p className="bolded">
          Oletko haaveillut hiihtovaelluksesta Lapissa? Tällä vain naisille
          suunnatulla vaelluksella pääset kokemaan talvisen Hetta–Pallas-reitin
          turvallisesti eräoppaan johdolla. Hiihdämme tunturisuksilla ahkiota
          vetäen keskellä Tunturi-Lapin talvista luontoa, yövymme varaustuvissa
          ja jatkamme aamuisin matkaa kohti seuraavaa etappia.
        </p>
        <br />
        <p>
          Vaellus on suunnattu hyväkuntoisille naisille, joita hiihtovaellus
          kiinnostaa, mutta joilla ei tarvitse olla aikaisempaa kokemusta
          hiihtovaeltamisesta. Valmistaudumme retkeen yhdessä jo ennen lähtöä,
          jotta tunturiin lähdetään hyvillä tiedoilla ja oikeilla varusteilla.
        </p>
        <br />
        <p>
          Hiihtovaellus kestää neljä päivää ja kolme yötä. Yövymme
          varaustuvissa, ja halutessasi voit kokeilla myös talvitelttailua,
          sillä mukana kulkee teltta.
        </p>
        <br />
        <p>
          Hetta–Pallas-reitti on noin 60 kilometriä pitkä. Hiihdämme huolletulla
          latureitillä, joka kulkee pääosin metsien ja soiden halki. Sioskurun
          ja Hannukurun välillä reitti vie meidät avotunturiin. Päivämatkat ovat
          noin 13–15 kilometriä.
        </p>
        <br />
        <p>
          Ennen vaellusta kokoonnumme Hetassa, jossa yövymme Hetan Majatalossa.
          Illan aikana käymme varusteet yhdessä läpi ja valmistaudumme
          seuraavana aamuna alkavaan hiihtovaellukseen. Majoitukseen sisältyvät
          illallinen, sauna ja aamiainen.
        </p>
      </div>
      <GatsbyImage
        image={data.campImg1.childImageSharp.gatsbyImageData}
        className="offering-img"
        alt="image"
      />
      <div className="camp-text-content">
        <p className="bolded">Hiihtovaelluksen opas</p>
        <p>
          Vaelluksen oppaana toimii Muoniossa asuva Sanni Lampinen, joka on
          koulutukseltaan eräopas ja fysioterapeutti. Sanni toimii oppaana myös
          Discover Laplandin kesävaelluksilla.
        </p>
        <br />
        <p>
          Sannille luonnossa liikkumisessa tärkeää eivät ole kiire ja
          suorittaminen, vaan ympäröivä luonto, tunturien rauha ja luonnossa
          syntyvät elämykset. Fysioterapeuttina häntä kiinnostaa myös luonnon ja
          liikkumisen vaikutus ihmisen kokonaisvaltaiseen hyvinvointiin.
        </p>
        <br />
        <p className="bolded">Ennen vaellusta valmistaudumme yhdessä</p>
        <p>
          Saat ennen vaellusta tarkan pakkaus- ja varustelistan,
          retkisuunnitelman sekä muut vaellukseen liittyvät ennakkomateriaalit.
        </p>
        <br />
        <p>
          Tapaamme ennen vaellusta kahdessa online-tapaamisessa, joissa käymme
          yhdessä läpi varusteet, vaatetuksen, retkiruoat ja niiden valmistuksen
          sekä muita hiihtovaellukseen valmistautumiseen liittyviä käytännön
          asioita.
        </p>
        <br />
        <p className="bolded">Online-tapaamiset:</p>
        <p>29.1.2027 klo 19-21 ja 2.3.2027 klo 19-21</p>
        <br />
        <p className="bolded">Hinta ja sisältö</p>
        <p>Hiihtovaelluksen hinta on 1 090 € / henkilö (sis. alv.)</p>
        <br />
        <p className="bolded">Hintaan sisältyy:</p>
        <p>
          Neljän päivän opastettu Hetta–Pallas-hiihtovaellus
          <br />
          Retki- ja turvallisuussuunnitelma
          <br />
          Tarkka pakkaus- ja varustelista
          <br />
          Ahkio, tunturisukset, monot ja sauvat
          <br />
          Kolme yötä varaustuvissa vaelluksen aikana
          <br />
          Yksi yö Hetan Majatalossa ennen vaellusta sisältäen illallisen, saunan
          ja aamiaisen
          <br />
          Varustekatsaus Hetassa ennen vaellusta
          <br />
          Kaksi online-tapaamista ennen vaellusta
          <br />
          Vaelluskohtainen WhatsApp-ryhmä
        </p>
      </div>
      <GatsbyImage
        image={data.campImg2.childImageSharp.gatsbyImageData}
        className="offering-img"
        alt="image"
      />
      <div className="camp-text-content">
        <p className="bolded">Mitä tarvitset itse?</p>
        <p>
          Säänmukaiset hiihtovaellusvaatteet ja taukokengät
          <br />
          Kolmen vuodenajan makuupussi ja makuualusta
          <br />
          Retkiruoat vaellukselle
          <br />
          Ruokailu- ja ruoanlaittovälineet
          <br />
          Vesipullo ja termospullo
          <br />
          Kuivasäkit tai kassit tavaroiden kuljettamiseen ahkiossa
        </p>
        <br />
        <p className="bolded">Vaatimustaso:</p>
        <p>
          Kyseessä on aloittelijoille suunnattu hiihtovaellus, joten aikaisempaa
          kokemusta hiihtovaelluksesta tai talvivaeltamisesta ei tarvita. Sinun
          tulee kuitenkin olla hyvässä kunnossa ja osata hiihtää perinteisellä
          hiihtotyylillä.
        </p>
        <br />
        <p>
          Päivämatkat ovat noin 13–15 kilometriä, ja etenemme tunturisuksilla
          ahkiota vetäen. Hiihtovaelluksella matkavauhti on tavallista
          perinteisen hiihtoa rauhallisempi, mutta usean peräkkäisen päivän
          hiihtäminen ja ahkion vetäminen tekevät vaelluksesta fyysisesti
          vaativan.
        </p>
        <br />
        <p className="bolded">Ilmoittautuminen</p>
        <p>
          Ilmoittaudu mukaan sähköpostitse osoitteeseen{' '}
          <a className="bolded" href="mailto:anettelatvapiikkila@gmail.com">
            anettelatvapiikkila@gmail.com
          </a>
          .
        </p>
        <br />
        <p>
          Otsikko: ALOITTELIJOIDEN HETTA–PALLAS-HIIHTOVAELLUS 2027
          <br />
          Koko nimi:
          <br />
          Ikä:
          <br />
          Puhelinnumero:
          <br />
          Paikkakunta:
          <br />
          Millainen aikaisempi kokemus sinulla on luonnossa liikkumisesta ja
          retkeilystä?
          <br />
          Millainen aikaisempi kokemus sinulla on hiihtämisestä?
          <br />
          Millainen kuntotasosi on? Kuinka paljon ja millä tavoin liikut
          normaalisti arjessa ja vapaa-ajalla?
          <br />
          Onko terveydentilassasi, toimintakyvyssäsi tai mahdollisissa vammoissa
          jotain, mikä meidän olisi hyvä tietää hiihtovaelluksen turvallisen
          toteuttamisen kannalta? Esimerkiksi astma, polvi-, lonkka-, selkä- tai
          nivelongelmat, aiemmat vammat tai muu fyysiseen rasitukseen vaikuttava
          tekijä:
          <br />
          Ruokavalio Hetan Majatalon illallista varten:
        </p>
        <br />
        <p className="bolded">Käytännön asiat</p>
        <p>
          - Varaathan matkasuunnitelmaasi yhden ylimääräisen yön siltä varalta,
          että sääolosuhteet viivästyttävät vaelluksen päättymistä.
          <br />- Osallistujat järjestävät ja maksavat itse matkansa Hettaan
          sekä paluumatkansa Pallakselta.
          <br />- Jos tarvitset autosi siirron Hetasta Pallakselle vaelluksen
          aikana, voimme auttaa sen sopimisessa paikallisen palveluntarjoajan
          kanssa. Auton siirto maksaa noin 100 € ja osallistuja maksaa palvelun
          suoraan palveluntarjoajalle.
        </p>
        <br />
        <p>
          Ilmoittautumiseen, maksamiseen ja peruutuksiin sovelletaan Discover
          Laplandin{' '}
          <Link className="bolded" to="/varaus-ja-peruutusehdot/">
            varaus- ja peruutusehtoja
          </Link>
          .
        </p>
        <br />
        <p>
          Tervetuloa unohtumattomalle hiihtovaellukselle Tunturi-Lappiin –
          lumen, hiljaisuuden ja avarien maisemien äärelle!
        </p>
      </div>
      <div className="offering-img-row">
        <GatsbyImage
          image={data.campImg3.childImageSharp.gatsbyImageData}
          className="offering-img-vert"
          alt="image"
        />
        <GatsbyImage
          image={data.campImg4.childImageSharp.gatsbyImageData}
          className="offering-img-vert"
          alt="image"
        />
      </div>
    </CampHoc>
  );
};

export const query = graphql`
  {
    campBg: file(
      relativePath: { eq: "images/crosscountry/ahkio-cabin-7.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    campImg1: file(
      relativePath: { eq: "images/crosscountry/ahkio-cabin-4.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    campImg2: file(
      relativePath: { eq: "images/crosscountry/ahkio-cabin-6.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    campImg3: file(
      relativePath: {
        eq: "images/crosscountry/hettapallas-hiihtovaellus-2023-1.jpg"
      }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    campImg4: file(
      relativePath: {
        eq: "images/crosscountry/hettapallas-hiihtovaellus-2023-2.jpg"
      }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    imageSEO: file(
      relativePath: { eq: "images/crosscountry/ahkio-cabin-4.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 1366, layout: FIXED)
        resize(width: 1366, height: 768, quality: 90) {
          src
        }
      }
    }
  }
`;

export default AloittelijoidenHettaPallasHiihtovaellus;
